module.exports = __webpack_public_path__ + "media/virtualStagingSlider/virtualStagingSlider5Pre-72c443c0.jpeg";